// Lib
import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

// Utils
import { pollCheckoutSessionStatus } from './appleInAppPurchasesService';

// Plugins
import { InAppPurchases } from '../../../../../capacitor_plugins/inAppPurchases';

// Constants
import { CAPACITOR_IN_APP_PURCHASES_PLUGIN_NAME } from '../../../../../capacitor_plugins/pluginConstants';

export default function () {
    useEffect(() => {
        if (!Capacitor.isPluginAvailable(CAPACITOR_IN_APP_PURCHASES_PLUGIN_NAME)) return;

        InAppPurchases.addListener('appStorePaymentCompleted', ({ checkoutSessionId }) => {
            (async () => {
                const checkoutStatus = await pollCheckoutSessionStatus(checkoutSessionId);
                InAppPurchases.onCheckoutSessionCompleted(checkoutStatus);
            })();
        });

        return () => {
            InAppPurchases.removeAllListeners();
        };
    }, []);
}
